<template>
  <Modal v-model="selectPublishStoreModal" :title="$t('key1000664')" width="550" :transfer="false" :mask-closable="false"
    @on-visible-change="selectPublishStoreChange">
    <Form ref="publishStoreForm" :model="selectPublishStoreForm" :label-width="100" :rules="ruleValidate" @submit.native.prevent>
      <Row>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="hideSite">
          <Form-item :label="$t('key1000665')" prop="siteIds">
            <Select v-model="selectPublishStoreForm.siteIds" filterable transfer multiple :placeholder="$t('key1000110')"
              @on-change="changeSite" style="width: 300px;">
              <Option v-for="(item, index) in siteList" :value="item.siteId" :key="index">{{ item.siteName }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1000666')" prop="ymsPlatformAccountId">
            <Select v-model="selectPublishStoreForm.ymsPlatformAccountId" filterable transfer @on-change="changeStore" style="width: 300px;">
              <Option v-for="(item, index) in publishStoreData" :value="item.saleAccountId" :key="index">{{ item.accountCode }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1000667')" prop="publishTemplateId">
            <div class="flex align-items">
              <Select v-model="selectPublishStoreForm.publishTemplateId" filterable transfer style="width: 300px;">
                <Option v-for="(item, index) in listingsTemplateList" :value="item.templateId" :key="index">{{ item.templateName }}</Option>
              </Select>
              <span class="distributorThemeColor cursor ml8" @click="goToListingPage('/yms/listing/template/index.htm')">{{ $t('key1000669') }}</span>
            </div>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1000668')" prop="ymsWarehouseId">
            <Select v-model="selectPublishStoreForm.ymsWarehouseId" filterable transfer style="width: 300px;">
              <Option v-for="item in shippingWarehouseList" :value="item.ymsWarehouseId" :key="item.ymsWarehouseId">{{ item.name }}</Option>
            </Select>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="selectPublishStoreModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="publishStoreBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {commonSessionStorage, getCommonTicket} from "@/utils/common";
import {NOSITEPLATFORMLIST} from "@/utils/enum";
import axios from "axios";

export default {
  name: "selectPublishStoreModal",
  mixins: [Mixin],
  data() {
    return {
      selectPublishStoreModal: false,
      selectPublishStoreForm: {
        siteIds: [], // 站点
        ymsPlatformAccountId: null, // 刊登店铺
        publishTemplateId: null, // 刊登模板
        ymsWarehouseId: null, // 商品发货仓
      },
      ruleValidate: {
        ymsPlatformAccountId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000660'), trigger: 'change'}
        ],
        publishTemplateId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000661'), trigger: 'change'}
        ],
        ymsWarehouseId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000662'), trigger: 'change'}
        ]
      },
      siteList: [],
      publishStoreList: [],
      listingsTemplateList: [],
      platformId: null,
      ymsProductId: null,
      type: null,
      shippingWarehouseList: [],
    }
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 隐藏对应的平台没有站点
    hideSite() {
      let talg = true;
      if (NOSITEPLATFORMLIST.includes(this.platformId)) {
        talg = false;
      }
      return talg;
    },
    // 处理站点数据
    publishStoreData() {
      const list = this.publishStoreList || [];
      const selectedSiteIds = (this.selectPublishStoreForm.siteIds || []).map(id => id?.toString().toLowerCase());
      const hasEmptySiteId = list.some(item => !item.siteId);
      if (hasEmptySiteId || selectedSiteIds.length === 0) {
        return list;
      }
      return list.filter(item => {
        const siteId = item.siteId?.toString().toLowerCase();
        return selectedSiteIds.includes(siteId);
      });
    }
  },
  methods: {
    // 初始化数据
    initSelectPublishStoreData(data, ymsProductId, type) {
      this.platformId = data.itemObj.platformId;
      this.ymsProductId = ymsProductId;
      this.type = type;
      this.publishStoreList = [];
      let list = data.itemObj.siteResultBos || [];
      this.siteList = this.uniqueFunc(list, 'siteId');
      let storeData = data.storeData || [];
      if (storeData.length > 0) {
        storeData.map((item) => {
          let accountInfoList = item.accountInfoList || [];
          if (accountInfoList.length > 0) {
            this.publishStoreList.push(...accountInfoList);
          }
        })
      } else {
        this.getPublishStoreData();
      }
      this.getShipmentWarehouseData();
      this.selectPublishStoreModal = true;
    },
    // 获取对应平台的店铺数据
    getPublishStoreData() {
      let v = this;
      let query = {
        platformId: v.platformId,
        status: 1 // 1'‑启用 '0'‑停用
      };
      v.axios.post(api.post_ymsDistributorProductInfo_querySaleAccountInfoListByPlatform, query).then(response => {
        v.tableLoading = false;
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data.length > 0) {
            data.map((item) => {
              let accountInfoList = item.accountInfoList || [];
              if (accountInfoList.length > 0) {
                v.publishStoreList.push(...accountInfoList);
              }
            })
          }
        }
      });
    },
    // 获取发货仓数据
    getShipmentWarehouseData() {
      this.shippingWarehouseList = [];
      this.axios.get(api.get_ymsWarehouse_api_querySpuDeliverWarehouse + this.ymsProductId).then(response => {
        if (response.data.code === 0) {
          this.shippingWarehouseList = response.data.datas || [];
        }
      });
    },
    // 选择站点
    changeSite(val) {
      this.selectPublishStoreForm.publishTemplateId = null;
      this.listingsTemplateList = [];
      if (val) {
        this.getListingsTemplateData();
      }
    },
    // 选择刊登店铺
    changeStore(val) {
      this.selectPublishStoreForm.publishTemplateId = null;
      this.listingsTemplateList = [];
      if (val) {
        this.getListingsTemplateData();
      }
    },
    // 获取对应平台刊登的模版数据
    getListingsTemplateData() {
      let v = this;
      let query = {
        platformId: v.platformId,
        saleAccountId: v.selectPublishStoreForm.ymsPlatformAccountId,
        siteIds: v.selectPublishStoreForm.siteIds
      };
      v.listingsTemplateList = [];
      v.axios.post(api.post_ymsDistributorProductInfo_queryTemplateByPlatform, query).then(response => {
        v.tableLoading = false;
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data.length > 0) {
            data.map((item) => {
              let templateInfoList = item.templateInfoList || [];
              if (templateInfoList.length > 0) {
                v.listingsTemplateList.push(...templateInfoList);
              }
            })
          }
        }
      });
    },

    // 确定
    publishStoreBtn() {
      let v = this;
      let query = {
        distributorMerchantId: v.userInfo.merchantId,
        ymsProductIds: [v.ymsProductId],
        type: v.type,
        platformIds: [v.platformId],
        siteIds: v.selectPublishStoreForm.siteIds,
        ymsPlatformAccountId: v.selectPublishStoreForm.ymsPlatformAccountId, // 刊登店铺
        publishTemplateId: v.selectPublishStoreForm.publishTemplateId, // 刊登模板
        ymsWarehouseId: v.selectPublishStoreForm.ymsWarehouseId, // 商品发货仓
      }
      v.$refs['publishStoreForm'].validate((valid) => {
        if (valid) {
          v.axios.post(api.post_ymsDistributorProductInfo_draft, query, {
            loading: true,
            loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')
          }).then(response => {
            if (response.data.code === 0) {
              v.selectPublishStoreModal = false;
              let data = response.data.datas;
              if (data) {
                let link = data.url;
                let status = data.status; // 1 成功 -1 失败
                if (status === 1) {
                  let obj = commonSessionStorage.getItem('erpConfig');
                  let merchant = Object.keys(obj).length > 0 ? obj.merchant : null;
                  let url = merchant.listingStatus === '1' ? merchant.listingDomain : merchant.ymsListingDomain;
                  if (url) {
                    let path = url.includes('http') ? url : 'https://' + url;
                    let iframeUrl = path + '/j_security_check?ticket=';
                    if (iframeUrl) {
                      let query = {
                        userId: v.userInfo.userId,
                        merchantId: v.userInfo.merchantId
                      }
                      getCommonTicket(query).then((ticket) => {
                        if (ticket) {
                          v.openNewWindowWithIframe(iframeUrl + ticket, link)
                        }
                      });
                    }
                  }
                } else {
                  /*v.$Message.error('刊登草稿失败！');*/
                  let platformResult = data.platformResult || [];
                  let list = [];
                  platformResult.map((item) => {
                    list.push(`<p>${item.platformId} ${item.reason}</p>`);
                  });
                  let content = list.join('');
                  v.$Modal.warning({
                    width: 600,
                    title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000663'),
                    content: content,
                    dangerouslyUseHTMLString: true,
                    okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000248'),
                  });
                  return false;
                }
              }
            }
          });
        }
      });
    },
    // 处理跳转
    openNewWindowWithIframe(iframeSrc, link) {
      let newWindow = window.open(iframeSrc, '_blank');
      if (newWindow) {
        setTimeout(() => {
          window.open(link, '_blank');
          newWindow.close();
        }, 1500);
      }
    },
    // 监听弹窗
    selectPublishStoreChange(value) {
      if (!value) {
        this.platformId = null;
        this.ymsProductId = null;
        this.type = null;
        this.$refs['publishStoreForm'].resetFields();
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ivu-form-item-label {
  padding-right: 0 !important;
}
</style>